import { isAxiosError } from 'axios'

export enum ErrorType {
  External = 'external',
  ImportError = 'import-error',
  Internal = 'internal',
  InvalidInput = 'invalid-input',
  InvalidParameter = 'invalid-parameter',
  MissingParameters = 'missing-parameters',
  MissingPermission = 'missing-permission',
  NotFound = 'not-found',
  NotPermitted = 'not-permitted',
  TooManyRequests = 'too-many-requests',
  Unauthorized = 'unauthorized',
}

export type ErrorReason = keyof {
  'already-participating': 'The person is already participating in the practice'
  'already-running': 'A request of the specified resource is already running; please wait and try again'
  'cannot-edit-used-resource': 'The resource you are trying to edit has already been used'
  'cyclic-dependency': 'The provided data cause a cyclic dependency'
  'different-practices': 'The resources belong to different practices'
  'duplicate-identifier': 'The identifier is already in use'
  'duplicate-main-resource': 'A main resource already exists'
  'duplicate-resource': 'The resource you are trying to create already exists'
  'duplicate-username': 'Username already registered'
  'existing-records': 'There are existing records that prevents the edit'
  'file-too-large': 'The file is too large'
  'feature-disabled': 'This feature is disabled'
  'invalid-conditions': 'The conditions to perform this action are not valid'
  'main-resource-not-signed': 'The main resource is not signed'
  'mandatory-password-change': 'The password must be changed on the first login'
  'no-default-left': 'No default resource left'
  'no-hidden-default': 'The default resource cannot be hidden'
  'not-assignable': 'The resource cannot be assigned'
  'not-assigned': 'You are not assigned to this resource'
  'resource-not-signed': 'The resource is not signed'
  'write-only-setting': 'The setting is write-only and this cannot be reverted'
}

export interface WSError {
  type: ErrorType
  message: string
  reason?: ErrorReason
}

export function isWSError(axiosBody: unknown): axiosBody is WSError {
  return (
    axiosBody != null &&
    typeof axiosBody === 'object' &&
    'type' in axiosBody &&
    typeof axiosBody.type === 'string' &&
    Object.values(ErrorType).includes(axiosBody.type as ErrorType) &&
    'message' in axiosBody &&
    typeof axiosBody.message === 'string'
  )
}

export function extractWsError(error: Error) {
  if (isAxiosError(error) && isWSError(error.response?.data)) {
    return error.response?.data
  }
}
